import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './auth/signin/signin.component';
import { RedirectComponentComponent } from './auth/redirect-component/redirect-component.component';
import { UserRouteAccessService } from './core/auth/user-route-access.service';
import { HomeModule } from './home/home.module';
import { GuestGuard } from './auth/guards/guest.guard';
import { RootRedirectGuard } from './auth/guards/root-redirext.guard';
import { AuthGuard } from './auth/guards/auth.guard';
import { LoggedInMatch } from './auth/guards/logged-in.match';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { LoginOtpComponent } from './auth/Login-OTP/login-otp.component';
import { RoleListComponent } from './hrms/role-mapping/view/role-list/role-list.component';
import { RoleEditComponent } from './hrms/role-mapping/view/role-edit/role-edit.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
// import { UserRoleListComponent } from './hrms/user-role mapping/View/user-role list/user-role-list.component';

const routes: Routes = [
  // If logged in and at "/", go to /home
  {
    path: '',
    pathMatch: 'full',
    canMatch: [LoggedInMatch],
    redirectTo: 'home',
  },

  // If NOT logged in and at "/", go to /login
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  // Public login (hide navbar)
  {
    path: 'login',
    canActivate: [GuestGuard],
    data: { hideNavbar: true },
    component: SigninComponent,
  },
   // Public forgot password (hide navbar)
  {
    path: 'forgot-password',
    canActivate: [GuestGuard],
    data: { hideNavbar: true },
    component: ResetPasswordComponent,

  },
  {
    path: 'login-otp',
    canActivate: [GuestGuard],
    data: { hideNavbar: true },
    component: LoginOtpComponent,
  },
  {
  path: 'user-roles',
  canActivate: [AuthGuard],
  data: { hideNavbar: false },
  component: RoleListComponent,
},
{
  path: 'roles/:id',
canActivate: [AuthGuard],
data: { hideNavbar: false },
component: RoleEditComponent,
},
{
path: 'roles/new',
canActivate: [AuthGuard],
data: { hideNavbar: false },
component: RoleEditComponent,
},
 {
    path: 'change-password',
    canActivate: [GuestGuard],
    data: { hideNavbar: true },
    component: ChangePasswordComponent,
  },
  // Optional: any special redirect component you already have
  { path: 'redirect', component: RedirectComponentComponent },

  // Protected area
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },

  {
    path: 'hrms/workforce',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hrms/workforce/workforce.module').then(
        (m) => m.WorkforceModule
      ),
  },
  {
    path: 'hrms/shift',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hrms/shift/shift.module').then((m) => m.ShiftModule),
  },
  {
    path: 'hrms/rostering',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hrms/rostering/rostering.module').then(
        (m) => m.RosteringModule
      ),
  },
  {
    path: 'hrms/attendance',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hrms/attendance/attendance.module').then(
        (m) => m.AttendanceModule
      ),
  },
  {
    path: 'hrms/policies',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hrms/policies/policies.module').then((m) => m.PoliciesModule),
  },
  {
    path: 'customer',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hrms/customer/customer.module').then((m) => m.CustomerModule),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },

  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },

  // Fallback
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
